import * as Yup from "yup";
import { REGEX } from "../../../utils/constants";
/**
 * @description declaration form schema for client validations
 */
export const userSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email address field  is required"),
  password: Yup.string()
    .matches(/^\S*$/, "Space is not allowed")
    .min(8, "Password must be atleast 8 characters long")
    .max(50, "Maximum 50 symbols")
    .required("Password field is required")
    .matches(
      REGEX.PASSWORD,
      "Password must contain atleast one alphabet, one special character and one numeric value"
    ),
  confirmPassword: Yup.string()
    .required("Confirm password field is required")
    .oneOf([Yup.ref("password"), null], "Passwords must match"),
  fname: Yup.string()
    .trim()
    .required("This field is required")
    .max(50, "This field should be maximumun 50 characters.")
    .matches(REGEX.NAME, "This field only accepts alphabets!"),
  lname: Yup.string()
    .trim()
    .required("This field is required")
    .max(50, "This field should be maximumun 50 characters.")
    .matches(REGEX.NAME, "This field only accepts alphabets!"),
  phone: Yup.string()
  .trim()
  .matches(
    /^(\([0-9]{3}\) |[0-9]{3}-)?[0-9]{3}-[0-9]{4}$/,
    "Invalid Phone Number"
  )
  .required("This field is required"),
  location: Yup.string().required("This field  is required"),
  purchase_advice: Yup.bool().oneOf([true, false]),
});

/**
 * @description declaration form schema for user update validations
 */
export const userUpdateSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email address field  is required"),
  fname: Yup.string()
    .trim()
    .required("This field is required")
    .max(50, "This field should be maximumun 50 characters.")
    .matches(REGEX.NAME, "This field only accepts alphabets!"),
  lname: Yup.string()
    .trim()
    .required("This field is required")
    .max(50, "This field should be maximumun 50 characters.")
    .matches(REGEX.NAME, "This field only accepts alphabets!"),
    phone: Yup.string()
    .trim()
    .matches(
      /^(\([0-9]{3}\) |[0-9]{3}-)?[0-9]{3}-[0-9]{4}$/,
      "Invalid Phone Number"
    )
    .required("This field is required"),
  // location: Yup.string().required("This field  is required"),
  purchase_advice: Yup.bool().oneOf([true, false]),
});

/**
 * @description params intilaization
 */

export const userInit = {
  email: "",
  password: "",
  phone: "",
  fname: "",
  lname: "",
  location: "",
  confirmPassword: "",
  purchase_advice: false,
  roles: "",
  permissions: [],
};
